module.exports = __webpack_public_path__ + "static/media/2018_conf _Escaping_the_Build_Trap.30324c97.png";